const clusterlets =  [
        {
            "name": "Analytics401",
            "id": "jQ3r5VEk1qwwKK5GUqBVBp-401",
            "type": 3,
            "position": {
                "x": 678,
                "y": 60
            },
            "attributes": {
                "parent": "controller"
            }
        },
        {
            "name": "Sensor101",
            "id": "oft3c5R8B3ebY5au9hnTz1-101",
            "type": 4,
            "position": {
                "x": 517,
                "y": -88
            },
            "attributes": {}
        },
        {
            "name": "Delegate201",
            "id": "jcoUMPJH3PEfKW1NMp2LzT-201",
            "type": 1,
            "position": {
                "x": 191,
                "y": -95
            },
            "attributes": {
                "type": "http2_delegate"
            }
        },
        {
            "name": "Digital_Twin301",
            "id": "nJbUsF7skLFtmyT29y96zs-301",
            "type": 2,
            "position": {
                "x": 234,
                "y": 69
            },
            "attributes": {
                "parent": "controller"
            }
        },

        {
            "name": "Digital_Twin303",
            "id": "nJbUsF7skLFtmyT29y96zs-303",
            "type": 2,
            "position": {
                "x": 234,
                "y": 69
            },
            "attributes": {
                "parent": "controller"
            }
        }
]

export default clusterlets